import { Loading } from './components';

import LoginError from './components/generic/PermissionsError/LoginError';
import AppRoutes from './routes/AppRoutes';
import { usePermissions } from './hooks/usePermissions';
import { UserProvider } from './context/PermissionsContext';

export default function App() {
  const { isLoading, error, userData } = usePermissions();

  if (isLoading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex justify-center items-center">
        <LoginError message={error.message} />
      </div>
    );
  }

  return (
    <UserProvider userData={userData}>
      <AppRoutes />
    </UserProvider>
  );
}
